<template>
	<div>
<div class="colhead">
			<h2 class="header_h2">预约查询</h2>
		</div>
		<el-header style="height: 85px;">
			<ul style="float: left;text-align: left;">
				<li>
					分院:&emsp;<el-select v-model="curbranchid" placeholder="请选择分院" style="width: 200px;" >
						<el-option v-for="item in branchlist" :label="item.branch_name" :value="item.branch_id">
							{{ item.branch_name }}
						</el-option>
					</el-select>
					&emsp;日期:&emsp;<el-date-picker style="width: 140px;" v-model="datestart" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期">
					</el-date-picker>&emsp;到&emsp;
					<el-date-picker style="width: 140px;" v-model="dateend" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期">
					</el-date-picker>
					&emsp;<el-button @click="btnQ()">查询</el-button>
				</li>
			</ul>

		</el-header>
<el-main>
	

		<el-table tooltip-effect="dark" :data="BranchBookDetail">
			<el-table-column prop="bookdate" label="预约日期" width="120px">
<template slot-scope="scope">
				{{formatdate(scope.row.bookdate)}}
				</template>
			</el-table-column>
			<el-table-column prop="type_name" label="预约类型" width="100px"></el-table-column>
			<el-table-column prop="timestep" label="时间段" width="100px"></el-table-column>
			<el-table-column prop="bookstatus" label="预约状态" width="100px">
				<template slot-scope="scope">
				<label v-if='scope.row.bookstatus=="1"'>预约成功</label>
				<label v-if='scope.row.bookstatus=="2"'>取消预约</label>
				</template>
			</el-table-column>
			<el-table-column prop="checkno" label="体检号" width="150px"></el-table-column>
			<el-table-column prop="cusname" label="姓名" width="130px"></el-table-column>
			<el-table-column prop="cussex" label="性别" width="80px">
				<template slot-scope="scope">
					<div v-for="item in Sex">
						<label v-if='scope.row.cussex==item.value'>{{item.key}}</label>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="ordername" label="所属单位" width="300px"></el-table-column>
			
		</el-table>

</el-main>
	</div>
</template>

<script>
	import enums from '../../commontools/enums.js'
	import book from '../../apifunction/Book.js'
	import branch from '../../apifunction/Branch.js'
	export default {
		data() {
			return {
				branchlist: [],
				BranchBookDetail: [],
				curbranchid: '',
				datestart: this.CommonFun.GetNowDate(),
				dateend: this.CommonFun.GetDateByAddDay(this.CommonFun.GetNowDate(),7),
				Sex:this.$enums.Sex
			}
		},
		mounted() {
			this.GetBranchAll();
		},
		methods: {
			formatdate(d) {
				return this.$moment(d).format("YYYY-MM-DD");
			},
			GetBranchAll() {
				branch.GetAllBranch()
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.branchlist = JSON.parse(ent.Data);
							if(this.branchlist.length>0)
							this.curbranchid=this.branchlist[0].branch_id;

						} else
							this.$message.info(ent.Msg);
					})
			},
			btnQ() {
				if(this.curbranchid==''||this.datestart==null||this.dateend==null)
				{
					this.$message.info('请选择查询分院和日期！');
					return;
				}
				book.GetBranchBookedDetailByBookDate(this.curbranchid, this.datestart, this.dateend)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.BranchBookDetail = JSON.parse(ent.Data);

						} else
							this.$message.info(ent.Msg);
					})
			},
		}
	}
</script>

<style>
</style>
